<template>
  <div v-if="view === 'home'" class="trust-us-container margin-general">
    <div class="trust-us-text">
      <div class="trust-us-text-container">
        <h2 v-html="formatContent('trust-us.title', $t, localPath)"></h2>
        <template v-for="(item, index) in contentProp" :key="index">
          <template v-if="item.type === 'paragraph'">
            <p class="body-4 trust-us-text">{{ $t(item.text) }}</p>
          </template>
          <template v-else-if="item.type === 'list'">
            <ul>
              <li class="body-4 trust-us-text" v-for="(listItem, idx) in item.items" :key="idx">{{ $t(listItem) }}</li>
            </ul>
          </template>
        </template>
      </div>
    </div>
    <div class="trust-us-carousel">
      <div class="container">
        <div v-for="item in items1" :key="item" class="item">
          <img class="logo" :src="`/images/payment_methods/${item.name}.svg`" :alt="item.alt" loading="lazy" decoding="async"/>
        </div>
      </div>
      <div class="container">
        <div v-for="item in items2" :key="item" class="item2">
          <img class="logo" :src="`/images/payment_methods/${item.name}.svg`" :alt="item.alt" loading="lazy" decoding="async"/>
        </div>
      </div>
  </div>
    <template v-for="(item, index) in contentProp" :key="index">
      <template v-if="item.type === 'paragraph'">
        <p class="body-4 trust-us-text-2">{{ $t(item.text) }}</p>
      </template>
      <template v-else-if="item.type === 'list'">
        <ul>
          <li class="body-4 trust-us-text-2" v-for="(listItem, idx) in item.items" :key="idx">{{ $t(listItem) }}</li>
        </ul>
      </template>
    </template>
  </div>
  <div v-if="view === 'company'" class="trust-us-carousel margin-general trust-us-container">
    
    <div class="trust-us-carousel desktop-only">
      <div class="container">
        <div v-for="item in items1" :key="item" class="item">
          <img v-if="item.name" class="logo" :src="`/images/payment_methods/${item.name}.svg`" :alt="item.alt" loading="lazy" decoding="async"/>
        </div>
      </div>
      
      <div class="container">
        <div v-for="item in items2" :key="item" class="item2">
          <img v-if="item.name" class="logo" :src="`/images/payment_methods/${item.name}.svg`" :alt="item.alt" loading="lazy" decoding="async"/>
        </div>
      </div>
    </div>

    <div class="trust-us-text">
      <div class="trust-us-text-container">
        <h2>{{ $t("company.trust-us.title") }}</h2>

        <div class="trust-us-carousel mobile-only">
          <div class="container">
            <div v-for="item in items1" :key="item" class="item">
              <img v-if="item.name" class="logo" :src="`/images/payment_methods/${item.name}.svg`" :alt="item.alt" loading="lazy" decoding="async"/>
            </div>
          </div>
          <div class="container">
            <div v-for="item in items2" :key="item" class="item2">
              <img v-if="item.name" class="logo" :src="`/images/payment_methods/${item.name}.svg`" :alt="item.alt" loading="lazy" decoding="async"/>
            </div>
          </div>
        </div>
        <template v-for="(item, index) in contentProp2" :key="index">
          <template v-if="item.type === 'paragraph'">
            <p class="body-4 trust-us-text">{{ $t(item.text) }}</p>
          </template>
          <template v-else-if="item.type === 'list'">
            <ul>
              <li class="body-4 trust-us-text" v-for="(listItem, idx) in item.items" :key="idx">{{ $t(listItem) }}</li>
            </ul>
          </template>
        </template>
      </div>
    </div>
    
    <template v-for="(item, index) in contentProp2" :key="index">
      <template v-if="item.type === 'paragraph'">
        <p class="body-4 trust-us-text-2">{{ $t(item.text) }}</p>
      </template>
      <template v-else-if="item.type === 'list'">
        <ul class="trust-us-text-2">
          <li class="body-4 trust-us-text-2" v-for="(listItem, idx) in item.items" :key="idx">{{ $t(listItem) }}</li>
        </ul>
      </template>
    </template>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { formatContent } from '~/utils/formatContent'

const props = defineProps({
  view: String,
  contentProp: {
    type: Array,
    required: false,
  },
  contentProp2: {
    type: Array,
    required: false,
  },
})

// Usar useLocalePath correctamente
const localPath = useLocalePath()

const items1 = ref([
  { name: 'bmo', alt: 'BMO' },
  { name: 'sepa', alt: 'sepa' },
  { name: 'Mastercard', alt: 'Mastercard' },
  /* { name: 'bbva', alt: 'BBVA' },
  { name: 'bcp', alt: 'BCP' },
  { name: 'bitpay', alt: 'Bitpay' }, */
])

const items2 = ref([
  { name: 'skrill', alt: 'Skrill logo' },
  { name: 'neteller', alt: 'Neteller logo' },
  { name: 'VISA', alt: 'VISA' },
  /* { name: 'fasapay', alt: 'Fasapay logo' },
  { name: 'pix', alt: 'Pix logo' },
  { name: 'bitwallet', alt: 'Bitwallet' }, */
])

/* const items3 = ref([
  { name: 'gigadat', alt: 'Gigadat logo' },
  { name: 'interac', alt: 'Interac logo' },
  { name: 'jpay', alt: 'Jpay logo' },
  { name: 'jpconnect', alt: 'Jpconnect logo' },
  { name: 'limitless', alt: 'Limitless logo' },
  { name: 'maybank', alt: 'Maybank logo' },
])

const items4 = ref([
  { name: 'proven', alt: 'Proven logo' },
  { name: 'skrill', alt: 'Skrill logo' },
  { name: 'sticpay', alt: 'Sticpay logo' },
  { name: 'unionpay', alt: 'unionpay logo' },
  { name: 'uphold', alt: 'Uphold logo' },
  { name: 'neteller', alt: 'Neteller logo' },
]) */

const contentProp = ref([
  {
    type: 'list',
    items: ['trust-us.description1', 'trust-us.description2'],
  },
])

const contentProp2 = ref([
  {
    type: 'list',
    items: ['trust-us.description1', 'trust-us.description2'],
  },
])
</script>